import styled from '@emotion/styled';
import { mediaQueries } from '../../../style/global-style';

export const StyledCabinTypeSection = styled.section`
    color: ${(props) => props.theme.colorsUnifications.gunmetal['100']};
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 36px;

    h1 {
        font-size: ${(props) => props.theme.fontSize.headlineXXL};
        line-height: 1.2;
        margin-bottom: 16px;
        margin-top: 36px;
    }

    h3 {
        font-size: 24px;
        margin-top: 36px;
        margin-bottom: 30px;
    }
    h1,
    h3 {
        @media ${mediaQueries.desktopAndUp} {
            margin-top: 80px;
        }
    }
`;

export const StyledCabinTitle = styled.p`
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 16px;
    color: ${(props) => props.theme.colorsUnifications.gunmetal['100']};
`;

export const StyledSubCabinContentHeading = styled.div`
    font-weight: 700;
    line-height: 24px;
`;

export const StyledSubCabinContent = styled.div`
    margin-bottom: 24px;
`;

export const StyledSubCabinContentItem = styled.p`
    position: relative;
    font-size: ${(props) => props.theme.fontSize.regularS};
    line-height: ${(props) => props.theme.lineHeight.headlineL};
    margin: 8px 0;
    padding-left: 28px;
    &:before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        width: 14px;
        height: 14px;
        margin-top: -7px;
        border: 4px solid ${(props) => props.theme.colorsUnifications.azure['20']};
        background-color: ${(props) => props.theme.colorsUnifications.azure['100']};
        border-radius: 100%;
    }
`;

export const StyledCabinAmenitiesContainer = styled.div`
    display: flex;
    justify-content: flex-start;
`;
